import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {TeslaGameConfig} from "../TeslaGameConfig";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {TeslaReelView} from "../reel/TeslaReelView";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {TeslaGameAssets} from "../TeslaGameAssets";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

/**
 * Class description
 *
 * Created: 2017-06-20
 * @author jonas
 */
export class TeslaReelAreaView extends ReelAreaView {
    private _bottomReelViewContainer:PIXI.Container;
    private _reelBackground:PIXI.Container;

    private _reelBackgroundLayer:ScalableLayer;
    private _backgroundContainer:PIXI.Container;
    private _topReelViewContainer:PIXI.Container;


    constructor() {
        super();

        this._backgroundContainer = new PIXI.Container();
        this._backgroundContainer.name = "TeslaReelAreaView._backgroundContainer";

        this._reelBackground = new PIXI.Container();
        this._reelBackground.name = "TeslaReelAreaView._reelBackground";

        this._bottomReelViewContainer = new PIXI.Container();
        this._bottomReelViewContainer.name = "TeslaReelAreaView._bottomReelViewContainer";
        this._topReelViewContainer = new PIXI.Container();
        this._topReelViewContainer.name = "TeslaReelAreaView._topReelViewContainer";

        this._backgroundContainer.addChild(this._reelBackground);
        this._backgroundContainer.addChild(this._bottomReelViewContainer);


        //Add to layers
        this._reelBackgroundLayer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._reelBackgroundLayer.addChild(this._backgroundContainer);


        this.addChild(this._topReelViewContainer);
    }

    protected initAnimations():void {
        this.createReelBackground();
        this.addReelAreaMask();
    }

    protected addReelAreaMask():void {
        let reelWidth = TeslaGameConfig.instance.REEL_AREA_WIDTH;
        let reelHeight = TeslaGameConfig.instance.REEL_AREA_HEIGHT;
        let bottomMask = new PIXI.Graphics();

        bottomMask.beginFill(0xFF0000, 0.5);
        bottomMask.moveTo(0, -1);
        bottomMask.lineTo(reelWidth, -4);
        bottomMask.lineTo(reelWidth, reelHeight + 17);
        bottomMask.lineTo(-7, reelHeight + 11);
        bottomMask.lineTo(0, -1);
        bottomMask.endFill();

        this._bottomReelViewContainer.addChild(bottomMask);
        this._bottomReelViewContainer.mask = bottomMask;

    }


    public addReelView(reel:ReelController):void {
        super.addReelView(reel);
        const reelView:TeslaReelView = <TeslaReelView>reel.view;
        this._bottomReelViewContainer.addChild(reelView.bottomLayer);
        this._topReelViewContainer.addChild(reelView);
    }

    protected onResize(resizeData:IResizeData):void {
        this._backgroundContainer.position.set(TeslaGameConfig.instance.REEL_AREA_POS_X, TeslaGameConfig.instance.REEL_AREA_POS_Y);
        this.position.set(TeslaGameConfig.instance.REEL_AREA_POS_X, TeslaGameConfig.instance.REEL_AREA_POS_Y);
    }

    private createReelBackground():void {
        const sprite = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.REEL_BACKGROUND)[0]);
        sprite.position.set(-24, -18);
        this._reelBackground.addChild(sprite);
    }


}